<template>
    <form @submit="submitForm" novalidate="true">
        <v-card>
            <v-card-title>
                <span class="headline">{{editMode ? 'Редагування' : 'Додавання'}}</span>
            </v-card-title>
            <v-card-text>
                <v-container grid-list-md>
                    <v-layout v-if="!loading" wrap>
                        <v-flex xs12>
                            <v-text-field :error-messages="errors.name" v-model="form.name"
                                          label="Назва поотоку"></v-text-field>
                        </v-flex>
                        <v-flex xs12 md12>
                            <v-select
                                    :items="academicGroups"
                                    :error-messages="errors.academicGroup"
                                    v-model="form.academicGroup"
                                    item-text="name"
                                    item-value="id"
                                    return-object
                                    label="Академічні групи"
                                    multiple
                                    chips
                            ></v-select>
                        </v-flex>
                    </v-layout>
                    <loading-placeholder v-else></loading-placeholder>
                </v-container>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                        color="primary"
                        text
                        @click.native="$emit('shouldCloseAddEdit')"
                        :disabled="loadingSave"
                >Відміна
                </v-btn>
                <v-btn
                        color="primary"
                        type="submit"
                        :loading="loadingSave"
                        :disabled="loadingSave"
                >Зберегти
                </v-btn>
            </v-card-actions>
        </v-card>
    </form>
</template>

<script>
    import HttpService from "../../../../HttpService";
    import {remapErrors} from "../../../../helpers/errorsHelper";
    import LoadingPlaceholder from "../../../common/LoadingPlaceholder";

    export default {
        props: {
            editId: Number,
            editMode: Boolean,
        },
        components: {
            loadingPlaceholder: LoadingPlaceholder,
        },
        data: () => {
            return {
                form: {
                    name: null,
                    academicGroup: [],
                },
                errors: {
                    name: [],
                    academicGroup: [],
                },
                academicGroups: [],
                loading: false,
                loadingSave: false,
            }
        },
        mounted() {
            HttpService.getInstance()
                .get(`academicGroup/getAll/${this.$route.params.faculty}/${this.$route.params.speciality}/${this.$route.params.semester}`)
                .then(resp => {
                    this.academicGroups = resp.map(g => {
                        g.name = `${g.groupNumber} група`;
                        return g;
                    });
                });

            if (this.editMode) {
                this.loading = true;

                HttpService.getInstance()
                    .get(`lecturesSchedule/${this.editId}`)
                    .then(resp => {
                        this.loading = false;
                        this.form = resp;
                    })
            }
        },
        methods: {
            submitForm(e) {
                e.preventDefault();

                this.loadingSave = true;

                const dataToSave = {
                    ...this.form, ...{
                        speciality: {
                            id: this.$route.params.speciality,
                        },
                        semester: {
                            id: this.$route.params.semester,
                        },
                        subject: {
                            id: this.$route.params.subject,
                        }
                    }
                };

                HttpService.getInstance()
                    .post("lecturesSchedule", dataToSave)
                    .then(resp => {
                        this.loadingSave = false;
                        this.$emit("addedEdited");
                    })
                    .catch(err => {
                        this.loadingSave = false;
                        if (err.errors) {
                            this.errors = remapErrors(err.errors);
                        }
                    });
            },
        }
    }
</script>